import HorizontalLine from 'components/ui/HorizontalLine';
import { stringToCurrency } from 'utils/currency';
import { OrderProductData } from 'lib/bigcommerce/types';
import Img from 'components/Img';
import { PRODUCT_FALLBACK_IMAGE } from 'config/const';

interface OrderProductItemProps {
  product: OrderProductData;
}

const OrderProductItem: React.FC<OrderProductItemProps> = (props) => {
  const { product } = props;

  return (
    <>
      <div className="text-sf-blue-700">
        <div className="relative w-full py-6">
          <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
            <div className="relative w-full md:w-auto">
              <div className=" overflow-hidden rounded-md">
                <div className="relative w-full md:hidden">
                  <Img
                    width={500}
                    height={500}
                    url={null}
                    fallback={PRODUCT_FALLBACK_IMAGE}
                    layout={'responsive'}
                    quality={100}
                  />
                </div>
                <div className="relative hidden md:block md:h-[148px] md:w-[148px]">
                  {/* todo: @backend image does not exist on OrderProductData  */}
                  <Img
                    width={300}
                    height={300}
                    url={null}
                    fallback={PRODUCT_FALLBACK_IMAGE}
                    layout={'fill'}
                    objectFit={'contain'}
                    quality={100}
                  />
                </div>
              </div>
            </div>
            <div className="flex w-full flex-col items-center justify-center gap-y-1.5">
              <div className="relative flex w-full items-center justify-between gap-x-6">
                <div>
                  <p className="text-base font-medium">{product.name}</p>
                </div>
                <div></div>
              </div>
              {/* <div className="relative w-full">
               todo: @backend to implement minimum weight on bigcommerce
                <p className="text-xs">Minimum 800g | {stringToCurrency(product.priceUnit, ``)}</p>
              </div> */}
              <div className="relative w-full">
                <p className="text-sm font-medium">{stringToCurrency(product.priceTotal, ``)}</p>
              </div>
              <div className="relative w-full text-sm">
                {`${product.quantity} unit${product.quantity > 1 ? `s` : ``}`}
              </div>
            </div>
          </div>
        </div>
        <HorizontalLine />
      </div>
    </>
  );
};

export default OrderProductItem;
